import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import ErrorHandler from "../../common/ErrorHandler";
import auctionService from "../../services/auction/auction.service";
import userService from "../../services/user.service";

function AddEditLeadDetails(props) {
  const {
    handleChange,
    modalData,
    onHide,
    isEdit,
    handleSubmit,
    statesList,
    loading,
    existingLead,
    lookupLoading,
    claiming,
    handleTakeOwnership,
  } = props;

  const fmtDate = (d) =>
    d
      ? new Date(d).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "";

  // Overlap state for the Add form (never in edit mode).
  const overlap = !isEdit ? existingLead : null;
  const isOwnedByOther = overlap?.status === "owned";

  // A phone containing anything but digits can only be the masked
  // placeholder the backend sends when this user isn't allowed to see the
  // real number — never editable, since submitting it back would overwrite
  // the real phone with the mask itself.
  const isPhoneMasked = isEdit && /\D/.test(modalData.phone || "");

  const [plansList, setPlansList] = useState([]);
  const [segmentsList, setSegmentsList] = useState([]);

  useEffect(() => {
    const formData = new FormData();
    formData.append("platform_type", "Auction");
    userService.GetPlanList(formData).then((res) => {
      if (res?.status === 200) {
        setPlansList(
          res.data.map((plan) => {
            const prices = Object.values(plan.plan_term || {}).filter(
              (v) => v !== "" && v !== 0,
            );
            const minPrice = prices.length > 0 ? Math.min(...prices) : null;
            return { name: plan.plan_name, cost: minPrice };
          }),
        );
      }
    });

    auctionService.GetSuperSegments().then((res) => {
      if (res?.length && res?.length > 0) {
        setSegmentsList(res?.map((item) => item.name));
      }
    });
  }, []);

  const notInterestedReasons = [
    "Plan is Expensive",
    "Blacklisted By Financier",
    "Many Financiers not into the platform",
    "No more into used vehicle business",
    "Approvals not received in last subscription",
    "Already have multiple IDs",
    "By-mistake applied for Trade Advance",
  ].toSorted();

  try {
    return (
      <>
        <Modal
          {...props}
          size="md"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Body className=" p-0">
            <form onSubmit={handleSubmit}>
              <div className=" d-flex justify-content-between align-items-center position-sticky top-0 bg-white border-bottom border-1 px-3 py-2">
                <div>
                  <h5 className=" h5 fw-bold mb-1">
                    {isEdit ? "Update" : "Add"} Lead
                  </h5>
                  {!isEdit && (
                    <p className=" mb-0 text-muted text-sm">
                      Enter the lead details to add a new potential customer.
                    </p>
                  )}
                </div>
                <button
                  className=" btn btn-close"
                  onClick={() => {
                    onHide();
                  }}
                ></button>
              </div>

              <div className=" px-3 py-2">
                {/* <div className="d-flex justify-content-between align-items-start gap-4 flex-wrap mb-2">
                  <div>
                    <div className=" fw-semibold">{modalData?.name}</div>
                    <div className=" text-md opacity-75 text-nowrap">
                      {" "}
                      <i className=" bi bi-telephone"></i> {modalData?.phone}
                    </div>
                    <div className=" text-md text-dark mt-1 text-nowrap">
                      {" "}
                      <i className=" bi bi-geo-alt"></i>{" "}
                      {modalData?.inquiry?.city
                        ? modalData?.inquiry?.city + ","
                        : ""}{" "}
                      {modalData?.inquiry?.state}
                      {modalData?.create_by_name
                        ? ` - ${modalData?.create_by_name}`
                        : ""}{" "}
                    </div>
                  </div>
                </div> */}
                <>
                  <div className=" col-12">
                    <h6 className=" h6">Lead Details</h6>
                  </div>
                  <div className="row row-cols-1 row-cols-lg-2 gx-3 gy-2 mb-2">
                    <div className="">
                      <label className="mb-0 text-md text-nowrap fw-semibold">
                        Name <span className=" text-danger">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        className=" form-control shadow-none"
                        placeholder="Enter Name"
                        value={modalData.name}
                        onChange={(e) => handleChange(e)}
                        name="name"
                        required
                      />
                    </div>
                    <div className="">
                      <label className="mb-0 text-md text-nowrap fw-semibold">
                        Phone <span className=" text-danger">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        className=" form-control shadow-none"
                        placeholder="Enter Phone"
                        value={modalData.phone}
                        onChange={(e) => {
                          e.target.value = e.target.value
                            .replaceAll(/\D/g, "")
                            .slice(0, 10);

                          handleChange(e);
                        }}
                        name="phone"
                        required
                        disabled={isPhoneMasked}
                      />
                      {isPhoneMasked && (
                        <div className="text-muted text-sm mt-1">
                          <i className="bi bi-lock-fill"></i> You don't have
                          permission to view or edit the full phone number.
                        </div>
                      )}
                      {!isEdit && lookupLoading && (
                        <div className="text-muted text-sm mt-1">
                          <span
                            className="spinner-border spinner-border-sm me-1"
                            aria-hidden="true"
                          ></span>
                          Checking for an existing lead…
                        </div>
                      )}
                      {overlap &&
                        overlap.status === "claimable" &&
                        !claiming && (
                          <div className="alert alert-warning py-2 px-2 mt-1 mb-0 d-flex justify-content-between align-items-center gap-2">
                            <div className="text-sm">
                              <div className="fw-semibold">
                                {overlap.name || overlap.phone} already exists
                              </div>
                              <div className="text-muted">
                                {overlap.owner_name
                                  ? `Last updated ${fmtDate(overlap.last_change)} by ${overlap.owner_name}`
                                  : `Last updated ${fmtDate(overlap.last_change)}`}
                                {overlap.is_lead_closed ? " · closed" : ""}
                              </div>
                            </div>
                            <button
                              type="button"
                              className="btn btn-sm btn-warning text-nowrap fw-semibold"
                              onClick={handleTakeOwnership}
                            >
                              Take ownership
                            </button>
                          </div>
                        )}
                      {overlap &&
                        overlap.status === "claimable" &&
                        claiming && (
                          <div className="alert alert-success py-2 px-2 mt-1 mb-0 text-sm">
                            <i className="bi bi-check-circle-fill me-1"></i>
                            You're taking ownership of{" "}
                            <span className="fw-semibold">
                              {overlap.name || overlap.phone}
                            </span>
                            's lead. Fill the interest details and submit.
                          </div>
                        )}
                      {isOwnedByOther && (
                        <div className="alert alert-danger py-2 px-2 mt-1 mb-0 text-sm">
                          <div className="fw-semibold">
                            Owned by {overlap.owner_name || "another agent"}
                          </div>
                          <div>
                            Last updated {fmtDate(overlap.last_change)}
                            {overlap.claimable_on
                              ? ` · claimable on ${fmtDate(overlap.claimable_on)}`
                              : ""}
                          </div>
                        </div>
                      )}
                    </div>
                    <div>
                      <label className=" mb-0 text-md text-nowrap fw-semibold">
                        State <span className=" text-danger">*</span>{" "}
                      </label>
                      <Select
                        options={statesList?.map((state) => ({
                          value: state?.name,
                          label: state?.name,
                        }))}
                        placeholder="Select State"
                        value={
                          modalData.state
                            ? {
                                label: modalData.state,
                                value: modalData.state,
                              }
                            : null
                        }
                        onChange={(e) => {
                          e = {
                            ...e,
                            target: { value: e.value, name: "state" },
                          };
                          handleChange(e);
                          e.target.value = "";
                          e.target.name = "city";
                          handleChange(e);
                        }}
                        name="state"
                        required
                      />
                    </div>
                    <div>
                      <label className=" mb-0 text-md text-nowrap fw-semibold">
                        City <span className=" text-danger">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        className=" form-control shadow-none"
                        placeholder="Enter City"
                        value={modalData.city}
                        onChange={(e) => handleChange(e)}
                        name="city"
                        required
                      />
                    </div>
                  </div>
                </>
                <div className=" col-12">
                  <h6 className="h6">Lead Subscription Interest</h6>
                </div>
                <div className="">
                  {isEdit ? (
                    <div className=" mb-2">
                      {/* <label className="mb-0 text-md text-nowrap fw-semibold">
                        Status <span className=" text-danger">*</span>{" "}
                      </label> */}
                      <div class="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="subscription_interest"
                          id="interested"
                          value={true}
                          checked={modalData.subscription_interest}
                          onChange={(e) => handleChange(e)}
                        />
                        <label
                          className="form-check-label cursor-pointer text-md"
                          htmlFor="interested"
                        >
                          Interested
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          type="radio"
                          name="subscription_interest"
                          value={false}
                          className="form-check-input"
                          id="notInterested"
                          checked={!modalData.subscription_interest}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                        <label
                          className="form-check-label cursor-pointer text-md"
                          htmlFor="notInterested"
                        >
                          Not Interested
                        </label>
                      </div>
                    </div>
                  ) : null}
                  <div className=" border-start border-2 ps-2 mb-2">
                    {modalData.subscription_interest ? (
                      <>
                        <div className=" mb-2">
                          <label
                            htmlFor="plan_interest"
                            className="text-md fw-semibold"
                          >
                            Select Interested Plan
                            <span className=" text-danger">*</span>
                          </label>
                          <select
                            className="form-select shadow-none"
                            id="plan_interest"
                            name="plan_interest"
                            value={modalData.plan_interest}
                            onChange={(e) => handleChange(e)}
                          >
                            <option value="">Select Plan</option>
                            {plansList.map((plan, index) => (
                              <option key={`plan_${index}`} value={plan.name}>
                                {plan.name}
                                {plan.cost
                                  ? ` — ₹${plan.cost.toLocaleString("en-IN")}`
                                  : ""}
                              </option>
                            ))}
                          </select>
                          {/* <small className=" opacity-50">Plan Cost {modalData}</small> */}
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span className="text-md fw-semibold">
                            Segment Interest
                          </span>
                          <span
                            onClick={() => {
                              const allSelected = segmentsList.every(
                                (seg) => !!modalData.segment?.[seg],
                              );
                              segmentsList.forEach((seg) =>
                                handleChange({
                                  target: {
                                    type: "checkbox",
                                    name: "segment",
                                    value: seg,
                                    checked: !allSelected,
                                  },
                                }),
                              );
                            }}
                            style={{
                              cursor: "pointer",
                              fontSize: "0.8rem",
                              color: "#1a73e8",
                              fontWeight: 500,
                            }}
                          >
                            {segmentsList.every(
                              (seg) => !!modalData.segment?.[seg],
                            ) && segmentsList.length > 0
                              ? "Deselect All"
                              : "Select All"}
                          </span>
                        </div>
                        <div className="mb-2 d-flex flex-wrap gap-2">
                          {segmentsList.map((segment, index) => {
                            const selected = !!modalData.segment?.[segment];
                            return (
                              <span
                                key={`segment_${index}`}
                                onClick={() =>
                                  handleChange({
                                    target: {
                                      type: "checkbox",
                                      name: "segment",
                                      value: segment,
                                      checked: !selected,
                                    },
                                  })
                                }
                                style={{
                                  cursor: "pointer",
                                  padding: "4px 12px",
                                  borderRadius: "20px",
                                  fontSize: "0.8rem",
                                  fontWeight: 500,
                                  backgroundColor: selected
                                    ? "#1a73e8"
                                    : "#fff",
                                  color: selected ? "#fff" : "#333",
                                  border: `1.5px solid ${selected ? "#1a73e8" : "#ccc"}`,
                                  userSelect: "none",
                                }}
                              >
                                {segment}
                              </span>
                            );
                          })}
                        </div>
                        <div class="form-check form-switch mb-1">
                          <input
                            class="form-check-input text-dark"
                            type="checkbox"
                            role="switch"
                            id="ta_interest"
                            name="ta_interest"
                            checked={modalData.ta_interest}
                            onChange={(e) => handleChange(e)}
                          />

                          <label
                            htmlFor="ta_interest"
                            className=" form-check-label fw-semibold text-md"
                          >
                            Trade Advance
                          </label>
                        </div>
                        <div>
                          <label
                            htmlFor="follow_up_date"
                            className=" fw-semibold text-md"
                          >
                            Follow Up Date
                          </label>

                          <input
                            type="date"
                            className=" form-control shadow-none"
                            placeholder="Enter Subscription Avail Date"
                            id="follow_up_date"
                            name="follow_up_date"
                            value={modalData.follow_up_date}
                            onChange={(e) => handleChange(e)}
                            min={new Date().toISOString().split("T")[0]}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className=" mb-2">
                          <label
                            htmlFor="not_interested_reason"
                            className=" fw-semibold text-md"
                          >
                            Reason <span className=" text-danger">*</span>
                          </label>
                          <select
                            className="form-select shadow-none"
                            id="not_interested_reason"
                            name="not_interested_reason"
                            value={modalData.not_interested_reason}
                            onChange={(e) => handleChange(e)}
                            required
                          >
                            <option value="">Select Reason</option>
                            {notInterestedReasons.map((reason, index) => (
                              <option
                                key={`not_interested_reason_${index}`}
                                value={reason}
                              >
                                {reason}
                              </option>
                            ))}
                            <option value="Others">Others</option>
                          </select>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="">
                    <label htmlFor="remark" className=" fw-semibold text-md">
                      Remarks
                    </label>
                    <textarea
                      className="form-control shadow-none"
                      id="remark"
                      rows="3"
                      name="remark"
                      value={modalData.remark}
                      onChange={(e) => handleChange(e)}
                      placeholder="Enter Remarks"
                    ></textarea>
                  </div>
                </div>

                {isEdit ? (
                  <>
                    <div class="form-check form-switch mt-2 pt-0">
                      <input
                        class="form-check-input text-dark"
                        type="checkbox"
                        role="switch"
                        id="is_lead_closed"
                        name="is_lead_closed"
                        checked={modalData.is_lead_closed}
                        onChange={(e) => handleChange(e)}
                      />

                      <label
                        htmlFor="is_lead_closed"
                        className=" form-check-label cursor-pointer"
                      >
                        Close Lead
                      </label>
                    </div>
                    <div className=" mb-2 m-0 p-0">
                      <small className=" opacity-75 text-primary text-small m-0 p-0 text-capitalize">
                        *If checked, the lead will be closed and not shown in
                        the list.
                      </small>
                    </div>
                  </>
                ) : null}
              </div>
              <div className=" d-flex justify-content-end align-items-center gap-2 position-sticky bottom-0 bg-white border-bottom border-1 px-3 py-2">
                <button
                  className=" btn btn-light border btn-sm"
                  onClick={() => {
                    onHide();
                  }}
                >
                  Cancel
                </button>
                {loading ? (
                  <button className=" btn btn-dark btn-sm text-nowrap" disabled>
                    <span
                      class="spinner-border spinner-border-sm"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden" role="status">
                      Loading...
                    </span>{" "}
                    Loading...
                  </button>
                ) : (
                  <button
                    className=" btn btn-dark btn-sm text-nowrap"
                    disabled={isOwnedByOther}
                    title={
                      isOwnedByOther
                        ? "This lead is owned by another agent"
                        : undefined
                    }
                  >
                    {claiming
                      ? "Take Ownership"
                      : `${isEdit ? "Update" : "Add"} Lead`}
                  </button>
                )}
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  } catch (error) {
    return <ErrorHandler error={error} />;
  }
}

export default AddEditLeadDetails;
